import angular from 'angular'

import { toPosPixel } from '../utils/bits'
import browser from '../utils/browser'

angular
  .module('ggs.gallery-modal')
  .factory('GalleryModalStyleHandlers', GalleryModalStyleHandlersProvider)

function GalleryModalStyleHandlersProvider(
  rootQs,
  GSNApplyStyleTmpl) {

  const OWNER_TAG = __filename

  return function GalleryModalStyleHandlers(modalElmId) {

    // applyBorderRadius

    const BORDER_RADIUS_PLH = ':border-radius:'
    // Safari has a strange and annoying bug where an element with
    // border-radius stops clipping its children when a CSS transform is
    // applied to it. This z-index is a hack to trigger Safari to clip like it should.
    // This works by forcing the element to form a new stacking context.
    //
    // See: https://gist.github.com/ayamflow/b602ab436ac9f05660d9c15190f4fd7b
    const BORDER_RADIUS_SAFARI_BUGFIX = browser.WebKit ? 'z-index: 0;' : ''
    const BORDER_RADIUS_TMPL = `
      ${rootQs} #${modalElmId} .ggs-gallery-modal__component__head {
        border-top-left-radius: ${BORDER_RADIUS_PLH};
        border-top-right-radius: ${BORDER_RADIUS_PLH};
      }

      ${rootQs} #${modalElmId} .ggs-gallery-modal__component__showcase_horizontal-layout {
        border-top-left-radius: ${BORDER_RADIUS_PLH};
        border-bottom-left-radius: ${BORDER_RADIUS_PLH};
        ${BORDER_RADIUS_SAFARI_BUGFIX}
      }

      ${rootQs} #${modalElmId} .ggs-gallery-modal__component__showcase_without-head.ggs-gallery-modal__component__showcase_vertical-layout {
        border-top-left-radius: ${BORDER_RADIUS_PLH};
        border-top-right-radius: ${BORDER_RADIUS_PLH};
        ${BORDER_RADIUS_SAFARI_BUGFIX}
      }

      ${rootQs} #${modalElmId} .ggs-gallery-modal__component__showcase_without-pane.ggs-gallery-modal__component__showcase_vertical-layout {
        border-bottom-left-radius: ${BORDER_RADIUS_PLH};
        border-bottom-right-radius: ${BORDER_RADIUS_PLH};
        ${BORDER_RADIUS_SAFARI_BUGFIX}
      }

      ${rootQs} #${modalElmId} .ggs-gallery-modal__component__pane_vertical-layout {
        border-bottom-left-radius: ${BORDER_RADIUS_PLH};
        border-bottom-right-radius: ${BORDER_RADIUS_PLH};
      }

      ${rootQs} #${modalElmId} .ggs-gallery-modal__component__pane_horizontal-layout {
        border-top-right-radius: ${BORDER_RADIUS_PLH};
        border-bottom-right-radius: ${BORDER_RADIUS_PLH};
      }`

    const applyBorderRadius = GSNApplyStyleTmpl({
      ownerTag: OWNER_TAG,
      propKeys: 'modal_border_radius',
      castKeys: toPosPixel,
      styleTmpl: BORDER_RADIUS_TMPL,
      stylePlh: BORDER_RADIUS_PLH
    })

    // applyAttachFooter

    const ATTACH_FOOTER_PLH = ':attach-footer:'
    const ATTACH_FOOTER_TMPL = `
      ${rootQs} #${modalElmId} .ggs-gallery-modal__component__footer {
        position: ${ATTACH_FOOTER_PLH};
        left: 0;
        top: 100%;
      }`

    const applyAttachFooter = GSNApplyStyleTmpl({
      ownerTag: OWNER_TAG,
      propKeys: 'modal_attach_branding_footer',
      allowEmpty: false,
      styleFunc: (modal_attach_branding_footer) => {
        const position = modal_attach_branding_footer ? 'static' : 'absolute'
        return ATTACH_FOOTER_TMPL.replace(ATTACH_FOOTER_PLH, position)
      }
    })

    // applyShadowStyles

    const SHADOW_RADIUS_PLH = ':shadow-radius:'
    const SHADOW_STYLES_TMPL = `
      ${rootQs} #${modalElmId} .ggs-gallery-modal__component__shadow {
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: ${SHADOW_RADIUS_PLH};
      }`

    const applyShadowStyles = GSNApplyStyleTmpl({
      ownerTag: OWNER_TAG,
      propKeys: 'modal_border_radius',
      castKeys: toPosPixel,
      allowKey: 'modal_show_shadow',
      styleTmpl: SHADOW_STYLES_TMPL,
      stylePlh: SHADOW_RADIUS_PLH
    })

    return [
      applyBorderRadius,
      applyAttachFooter,
      applyShadowStyles
    ]
  }
}
